import { FC } from 'react';

import SunSvgAsset from './sun.svg?react';

export const SunSvg: FC<{ size: number; filter?: string }> = ({ size, filter }) => <SunSvgAsset width={size} height={size} style={{ filter }} />;
